export default __webpack_public_path__ + "media/images/60-b24d7145196b72977447f13f205c7cb6.jpg";